import { MatchingRule } from '__pages/SmartConnectors/types';
import { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';

export const useLastExecutableRuleWarning = (rules: MatchingRule[]) => {
  const listRef = useRef<HTMLDivElement>(null);
  const [warningPosition, setWarningPosition] = useState(0);

  const lastExecutableRuleIndex = useMemo(() => {
    const index = rules.findIndex(
      (rule) =>
        ![
          rule.no_match_action,
          rule.single_match_action,
          rule.multiple_match_action,
          rule.match_archive_action,
        ].some((action) => action.startsWith('next_rule'))
    );

    return index !== -1 && index < rules.length - 1 ? index : null;
  }, [rules]);

  const setPosition = useCallback(() => {
    if (lastExecutableRuleIndex !== null) {
      const lastExecutableRuleElement = Array.from(
        listRef.current?.children || []
      )[lastExecutableRuleIndex];

      if (lastExecutableRuleElement) {
        const { y, height } = lastExecutableRuleElement.getBoundingClientRect();
        const { y: listY } = listRef.current!.getBoundingClientRect();
        setWarningPosition(y - listY + height + 10);
      }
    }
  }, [lastExecutableRuleIndex]);

  useLayoutEffect(() => {
    setPosition();

    window.addEventListener('resize', setPosition);

    return () => {
      window.removeEventListener('resize', setPosition);
    };
  }, [setPosition]);

  return {
    lastExecutableRuleIndex,
    listRef,
    warningPosition,
  };
};
